
export const CONFIRMED_GET_SERVICE_CALLER_PRESCRIPTIONS_ACTION = 'CONFIRMED_GET_SERVICE_CALLER_PRESCRIPTIONS_ACTION';
export const CONFIRMED_GET_SERVICE_CALLER_PATIENT_DETAILS = 'CONFIRMED_GET_SERVICE_CALLER_PATIENT_DETAILS';
export const CONFIRMED_MARK_PRESCRIPTION_AS_COMPLETE = "CONFIRMED_MARK_PRESCRIPTION_AS_COMPLETE";
export const CONFIRMED_PRESCRIPTION_REASSIGN =
    "CONFIRMED_PRESCRIPTION_REASSIGN";
export const FAILED_PRESCRIPTION_REASSIGN =
    "FAILED_PRESCRIPTION_REASSIGN";

export const CONFIRMED_GET_REPEAT_PRESCRIPTIONS = "CONFIRMED_GET_REPEAT_PRESCRIPTIONS";
export const  FAILED_GET_REPEAT_PRESCRIPTIONS = "FAILED_GET_REPEAT_PRESCRIPTIONS";
